import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useConfig } from '../../context/config'

import { StyledLink } from './StyledLink'

// Email customer support link
// Origin of the feature: https://cardohealth.atlassian.net/browse/CAR-3218
export const EmailSupportLink = () => {
  const { config } = useConfig()
  const { t } = useTranslation()

  // WARNING: Mind that we cannot be sure that the email is present in the config, and the
  // CAR-3218 does not define what to do in such edge case. It may be a source of inconsistency.
  const supportEmail = useMemo(() => {
    const emailSupportSubject = t('screens.welcome.registrationOrientation.emailSupportSubject')
    const emailSupportBody = t('screens.welcome.registrationOrientation.emailSupportBody')
    const emailAddress = config.partnerConfig.supportProvider.info?.email

    return `mailto:${emailAddress}?subject=${emailSupportSubject}&body=${emailSupportBody}`
  }, [config.partnerConfig.supportProvider.info?.email, t])

  return <StyledLink href={supportEmail}>Email</StyledLink>
}
